import { ApiScanNote } from '../ApiSchemas';

/**
 * Build a set of note IDs that have been logically deleted by append-only `delete` notes.
 */
export const getDeletedParentScanNoteIds = (
  scanNotes: Array<{
    scanNoteType: ApiScanNote['scanNoteType'];
    parentScanNoteId?: string | null;
  }>,
): Set<string> => {
  const deletedParentIds = new Set<string>();

  for (const note of scanNotes) {
    if (note.scanNoteType === 'delete' && note.parentScanNoteId) {
      deletedParentIds.add(note.parentScanNoteId);
    }
  }

  return deletedParentIds;
};
